

import React from 'react';
import { Typography, styled } from '@mui/material';

const SectionHeader = ({ icon, title }) => (
  <Typography 
    variant="h6" 
    sx={{
      padding: (theme) => theme.spacing(1.5, 2),
      backgroundColor: (theme) => theme.palette.primary.main,
      color: (theme) => theme.palette.primary.contrastText,
      borderTopLeftRadius: (theme) => theme.shape.borderRadius * 2,
      borderTopRightRadius: (theme) => theme.shape.borderRadius * 2,
      display: 'flex',
      alignItems: 'center',
      gap: (theme) => theme.spacing(1),
      fontWeight: 500,
    }}
  >
    {icon} {title}
  </Typography>
);

export default SectionHeader;